import { getFeature } from 'Cloud/Application/FeaturesEs6';

const publicPasswordFileValue: 'a' | 'b' = getFeature('public-password-file');

export const isPublicPasswordFileEnabled = publicPasswordFileValue === 'b';
